import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";

const headingStyles: RichtextAdapterProps["customStyles"] = {
  heading: {
    mb: { base: 2, lg: 0 },
  },
  link: {
    _visited: {},
    fontSize: "lg",
  },
};
const textStyles: RichtextAdapterProps["customStyles"] = {
  paragraph: {
    _notLast: { mb: 2 },
  },
  link: {
    _visited: {},
  },
};

export { headingStyles, textStyles };
